export default {
    props:{
        state:{
            type: Object,
            default: null
        },
        enableClearState:{
            type: Boolean,
            default: true
        }
    },
    methods: {
        setState(name, data){
            let _data = JSON.parse(JSON.stringify(data));
            this.$set(this.states,name,_data);
            return {'ref':this, 'name':name, 'data': data};
        },
        clearState(name, data){
            let _data = JSON.parse(JSON.stringify(data));
            this.$set(this.states,name,_data);
        }
    },
    mounted() {
        this._state = this.state ? this.state: false;
    },
    data(){
        return{
            states:{},
            _state:false
        }
    }
};